import { graphql } from 'react-relay'

export const createEndorphinaUrlMutation = graphql`
  mutation GameEndorphinaCreateUrlMutation($input: CreateUrlInput!) {
    createUrl(input: $input) {
      url
    }
  }
`

export const launchGameMutation = graphql`
  mutation GameLaunchGameMutation($input: LaunchGameInput!) {
    launchGame(input: $input) {
      url
    }
  }
`

export const getNormalizedGameData = graphql`
  query GameGetNormalizedGameDataQuery($gameCode: String!) {
    getNormalizedGame(gameCode: $gameCode) {
      urlThumb
      aggregator
      gameId
      category
      provider
      label
      customThumb
      demoGameSupport
      releaseDate
      rtp
      meta
    }
  }
`